import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { range: String, startDate: String, endDate: String }
  static targets = ['popover', 'startDate', 'endDate']

  connect() {
    if (this.rangeValue === 'custom') {
      if (this.startDateValue) this.startDateTarget.value = this.startDateValue
      if (this.endDateValue) this.endDateTarget.value = this.endDateValue
    }

    this._outsideClick = (e) => {
      if (!this.element.contains(e.target)) this._hide()
    }
    document.addEventListener('click', this._outsideClick)
  }

  disconnect() {
    document.removeEventListener('click', this._outsideClick)
  }

  toggle() {
    this.popoverTarget.classList.toggle('hidden')
  }

  apply() {
    const start = this.startDateTarget.value
    const end = this.endDateTarget.value
    if (!start || !end) return

    const url = new URL(window.location.href)
    url.searchParams.set('range', 'custom')
    url.searchParams.set('start_date', start)
    url.searchParams.set('end_date', end)
    window.location.href = url.toString()
  }

  _hide() {
    this.popoverTarget.classList.add('hidden')
  }
}
